// removed by extract-text-webpack-plugin
module.exports = {"main":"_31xIblynNC2-6LFE3qC-YR","image":"_1qsGusSoj2YpduR420ZbSG","title":"_3AKS3yCle_BF_tiLZXRtfv","subtitle":"_2opHBmXpBy1YDI2gbikbvS","tag":"_3Awm931tnneAwQyQdXwkjo"};


//////////////////
// WEBPACK FOOTER
// ./components/Catalog/Tile.module.css
// module id = 2338
// module chunks = 1